import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SearchBar, SearchQuery } from "../../components/search_bar";
import { Employee } from "../../api/generated/models/Employee";
import { useState } from "react";
import { EmployeeService } from "../../api/generated";
import { EmployeeSearchTable } from "../../components/employeeSearchTable";
import { format } from "date-fns";
import { ymdDash } from "../../components/search_bar";

type EmployeSearchState =
  | { status: "INITIAL" }
  | { status: "LOADING" }
  | { status: "READY"; results: Employee[] }
  | { status: "ERROR"; error: Error };

export const Route = createFileRoute("/employee/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [searchState, setSearchState] = useState<EmployeSearchState>({
    status: "INITIAL",
  });
  const navigator = useNavigate();

  const handleSearch = async (query: SearchQuery) => {
    setSearchState({ status: "LOADING" });

    try {
      const result = await EmployeeService.getEmployees(
        query.query || undefined,
        mapDate(query.date) || undefined,
      );
      setSearchState({ status: "READY", results: result });
    } catch (error) {
      console.log(error);
      setSearchState({ status: "ERROR", error: error as Error });
    }
  };

  const mapDate = (date: Date | null) => {
    if (!date) {
      return undefined;
    }
    return format(date, ymdDash);
  };

  return (
    <div className="flex justify-center items-center mt-10">
      <div className="flex w-3/4 flex-col items-center">
        <SearchBar search={handleSearch} />
        <button
          className="btn btn-secondary m-4"
          onClick={() => navigator({ to: "/employee/new" })}
        >
          Nieuwe medewerker
        </button>
        <div className="mt-4 flex w-full flex-col items-center">
          {searchState.status === "INITIAL" && (
            <p className="text-gray-500 mt-4">Zoek naar medewerkers</p>
          )}
          {searchState.status === "LOADING" && (
            <p className="text-gray-500 mt-4">Laden...</p>
          )}
          {searchState.status === "ERROR" && (
            <p className="text-red-500 mt-4">
              Fout: {searchState.error.message}
            </p>
          )}
          {searchState.status === "READY" &&
            searchState.results.length == 0 && <p>Geen medewerkers gevonden</p>}

          {searchState.status === "READY" && searchState.results.length > 0 && (
            <EmployeeSearchTable
              employees={searchState.results}
              itemsPerPage={15}
              navigator={(id) =>
                navigator({
                  to: `/employee/$employeeId`,
                  params: { employeeId: id.toString() },
                })
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
